module.exports = __webpack_public_path__ + "img/stock1.7efe2898.png";